<template>
  <article
    class="teaser-shop teaser-shop--lg-width-33 teaser-shop--sm-width-50 t-98"
    :class="{ 'teaser-shop--has-normalized-height': !reducedTeaser }"
  >
    <slot name="beforePicture" />
    <div
      v-click-redirect="{ configPreset: 'teaser-default' }"
      class="teaser-shop__picture-wrapper"
      aria-hidden="true"
    >
      <figure v-if="$teaser.image" class="teaser-shop__picture">
        <div class="teaser-shop__picture-inner">
          <r-image
            :sources="$teaser.image.sources"
            :alt="$teaser.image.alt"
            :for-product-extension="true"
          />
          <div v-if="$extension.isNew" class="teaser-shop__sticker sticker-pin">
            <span
              ><a-label path="renderer.teaser.new" :is-visible="true"></a-label
            ></span>
          </div>
        </div>
      </figure>
    </div>
    <div class="teaser-shop__content">
      <header class="teaser-shop__header">
        <div class="teaser-shop__label-wrapper">
          <div
            v-if="$extension.overline"
            class="teaser-shop__label-overline label-overline"
          >
            <span>{{ $extension.overline }}</span>
          </div>
          <!-- <span
            v-if="$extension.soldOut"
            class="teaser-shop__price teaser-shop__price--out-of-stock"
            ><span class="a-visually-hidden"
              ><a-label path="renderer.teaser.cannotBeOrdered"></a-label></span
            ><a-label
              path="renderer.teaser.outOfStock"
              :is-visible="true"
            ></a-label
          ></span>
          <span v-else class="teaser-shop__price">{{ price }}</span> -->
          <span v-if="!$extension.soldOut" class="teaser-shop__price">{{
            price
          }}</span>
        </div>
        <r-heading :level="teaserHeadingLevel" class="teaser-shop__heading">
          <r-link
            class="teaser-shop__link"
            :url="$teaser.link.url"
            :target="$teaser.link.target"
          >
            {{ $teaser.title }}
          </r-link>
        </r-heading>
        <strong v-if="$extension.isNew" class="a-visually-hidden"
          ><a-label path="renderer.teaser.newInShop"></a-label
        ></strong>
        <bpb-bookmark :item-id="$meta.id"></bpb-bookmark>
        <div class="teaser-shop__meta">
          <div
            v-click-redirect="{ configPreset: 'teaser-default' }"
            class="teaser-shop__picture-wrapper"
            aria-hidden="true"
          >
            <figure class="teaser-shop__picture">
              <div class="teaser-shop__picture-inner">
                <r-image
                  :sources="$teaser.image.sources"
                  :alt="$teaser.image.alt"
                  :for-product-extension="true"
                />
                <div
                  v-if="$extension.isNew"
                  class="teaser-shop__sticker sticker-pin"
                >
                  <span
                    ><a-label
                      path="renderer.teaser.new"
                      :is-visible="true"
                    ></a-label
                  ></span>
                </div>
              </div>
            </figure>
          </div>
          <div class="teaser-shop__availability-wrapper">
            <!-- <span
              v-if="$extension.soldOut"
              class="teaser-shop__price teaser-shop__price--out-of-stock"
              ><span class="a-visually-hidden"
                ><a-label
                  path="renderer.teaser.cannotBeOrdered"
                ></a-label></span
              ><a-label
                path="renderer.teaser.outOfStock"
                :is-visible="true"
              ></a-label
            ></span> -->
            <span v-if="!$extension.soldOut" class="teaser-shop__price">{{
              price
            }}</span>
            <ul
              v-if="
                isAvailableIn.online || isAvailableIn.pdf || isAvailableIn.epub
              "
              class="availability"
            >
              <li v-if="isAvailableIn.online" class="availability-item">
                <bpb-icon
                  icon="i-checkmark"
                  label-path="renderer.teaser.availableFor"
                ></bpb-icon
                ><a-label
                  path="renderer.teaser.readOnline"
                  :is-visible="true"
                ></a-label>
              </li>
              <li v-if="isAvailableIn.pdf" class="availability-item">
                <bpb-icon
                  icon="i-checkmark"
                  label-path="renderer.teaser.availableAs"
                ></bpb-icon
                >PDF
              </li>
              <li v-if="isAvailableIn.epub" class="availability-item">
                <bpb-icon
                  icon="i-checkmark"
                  label-path="renderer.teaser.availableAs"
                ></bpb-icon
                >EPUB
              </li>
            </ul>
          </div>
        </div>
      </header>
      <p v-if="!reducedTeaser" class="teaser-shop__description">
        {{ $teaser.text }}
      </p>
      <footer
        v-if="isAvailableIn.online || isAvailableIn.pdf || isAvailableIn.epub"
        class="teaser-shop__footer"
      >
        <ul class="availability">
          <li v-if="isAvailableIn.online" class="availability-item">
            <bpb-icon
              icon="i-checkmark"
              label-path="renderer.teaser.availableFor"
            ></bpb-icon
            ><a-label
              path="renderer.teaser.readOnline"
              :is-visible="true"
            ></a-label>
          </li>
          <li v-if="isAvailableIn.pdf" class="availability-item">
            <bpb-icon
              icon="i-checkmark"
              label-path="renderer.teaser.availableAs"
            ></bpb-icon
            >PDF
          </li>
          <li v-if="isAvailableIn.epub" class="availability-item">
            <bpb-icon
              icon="i-checkmark"
              label-path="renderer.teaser.availableAs"
            ></bpb-icon
            >EPUB
          </li>
        </ul>
      </footer>
    </div>
  </article>
</template>

<script>
import { mapGetters } from 'vuex';
import { computedExtensionDefaults } from './extension.mixin.js';

export default {
  mixins: [computedExtensionDefaults],
  inject: {
    reducedTeaser: {
      default() {
        return false;
        // fail silently
      },
    },
    teaserHeadingLevel: { default: 3 },
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      lang: 'labels/activeLanguage',
    }),
    isAvailableIn() {
      let availability = {
        print: false,
        online: false,
        epub: false,
        pdf: false,
      };
      this.$extension.availability.forEach(type => {
        if (type === 'print') availability.print = true;
        if (type === 'online') availability.online = true;
        if (type === 'epub') availability.epub = true;
        if (type === 'pdf') availability.pdf = true;
      });
      return availability;
    },
    price() {
      return new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'EUR',
      }).format(this.$extension.price);
    },
  },
};
</script>
